import { Component, inject, ViewChild, ElementRef } from '@angular/core';

import { RouterOutlet, Router, NavigationEnd } from '@angular/router';
import { MainHeader } from '@app/pages/public/layout/main-header/main-header';
import { MainFooter } from '@app/pages/public/layout/main-footer/main-footer.component';
import { BackToTopComponent } from '@app/common/components/ui/back-to-top/back-to-top';
import { FloatingNavComponent } from '@app/common/components/ui/floating-nav/floating-nav';
import { PublicToastComponent } from '@app/common/components/ui/public-toast/public-toast.component';
import { CookieConsentComponent } from '@app/common/components/ui/cookie-consent/cookie-consent.component';
import { filter } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-main-layout',
  standalone: true,
  imports: [
    RouterOutlet,
    MainHeader,
    MainFooter,
    BackToTopComponent,
    FloatingNavComponent,
    PublicToastComponent,
    CookieConsentComponent,
  ],
  template: `
    <div>
      <app-main-header />
      <app-floating-nav />
      <app-public-toast />
      <app-cookie-consent />

      <main
        #scrollContainer
        class="public-content h-screen w-full overflow-y-scroll scroll-smooth block bg-(--site-bg)"
      >
        <router-outlet />
        <main-footer class="block" />
      </main>
    </div>

    <back-to-top [scrollTarget]="scrollContainer" />
  `,
  styles: `
    .public-content {
      box-sizing: border-box;
      padding-top: var(--public-banner-offset, 0rem);
    }
  `,
})
export class MainLayoutComponent {
  @ViewChild('scrollContainer') scrollContainer!: ElementRef;
  private router = inject(Router);

  constructor() {
    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        takeUntilDestroyed(),
      )
      .subscribe(() => {
        setTimeout(() => {
          if (this.scrollContainer) {
            this.scrollContainer.nativeElement.scrollTop = 0;
          }
        }, 10);
      });
  }
}
